import React from "react";
import useOkendo from "hooks/useOkendo";

const OkendoReviewsCarousel = ({ data }) => {
	const widgetContainer = useOkendo();

	return (
		<div>
			{data?.title && <h2 className="text-center">{data.title}</h2>}
			<div
				ref={widgetContainer}
				data-oke-carousel
			/>
		</div>
	);
};

export default OkendoReviewsCarousel;